import { isStringOrEncryptedField } from '@/infra/sse/shared/decryption'
import type { RawActivityEventPayload } from './types'

export const isRawActivityEventPayload = (obj: unknown): obj is RawActivityEventPayload => {
  if (typeof obj !== 'object' || obj === null) return false

  const candidate = obj as Record<string, unknown>

  if (
    typeof candidate['rawHookPayload'] !== 'object' ||
    candidate['rawHookPayload'] === null ||
    typeof candidate['eventType'] !== 'string' ||
    typeof candidate['hostDetails'] !== 'object' ||
    candidate['hostDetails'] === null ||
    typeof candidate['telemetry'] !== 'object' ||
    candidate['telemetry'] === null
  )
    return false

  const meta = candidate['eventMetadata']
  if (typeof meta !== 'object' || meta === null) return false

  const m = meta as Record<string, unknown>
  return (
    typeof m['timestamp'] === 'string' &&
    typeof m['userExternalId'] === 'string' &&
    typeof m['claudeSessionId'] === 'string' &&
    typeof m['eventId'] === 'string' &&
    typeof m['userPromptId'] === 'string' &&
    (m['hookType'] === null || typeof m['hookType'] === 'string') &&
    isStringOrEncryptedField(m['transcriptPath']) &&
    isStringOrEncryptedField(m['contextWorkDirectory']) &&
    (m['agentMode'] === null || typeof m['agentMode'] === 'string') &&
    // dangerouslySkipPermissions and autoModeSupported are intentionally lenient
    // (undefined accepted) — older daemon payloads predate these fields; downstream
    // treats undefined as "unknown".
    (m['dangerouslySkipPermissions'] === undefined ||
      typeof m['dangerouslySkipPermissions'] === 'boolean') &&
    (m['autoModeSupported'] === undefined || typeof m['autoModeSupported'] === 'boolean')
  )
}
